// extracted by mini-css-extract-plugin
export default {"procuct-container":"aECm5_procuct-container","img-top-content":"iGALo_img-top-content"};